import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  ViewEncapsulation,
  OnDestroy
} from '@angular/core';
import { BixiLayoutService } from './layout.service';
import { IBreadcrumb } from './layout.type';
import { Subscription } from 'rxjs';

@Component({
  selector: 'bixi-layout',
  templateUrl: './layout.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  exportAs: 'bixiLayout',
  host: {
    class: 'bixi-layout'
  }
})
export class BixiLayoutComponent implements OnDestroy {
  subscription = new Subscription();
  @Input() singleOpen = false;
  open = true;
  showHeader = true;
  breadcrumbs: IBreadcrumb[];
  constructor(
    private layoutService: BixiLayoutService,
    private cdr: ChangeDetectorRef
  ) {
    this.subscription.add(
      this.layoutService.headerVisible$.subscribe((open: boolean) => {
        this.showHeader = open;
        this.cdr.markForCheck();
      })
    );
  }

  onOpenChange() {
    this.layoutService.toggleMenu();
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
